import api from '@/api/index.js'

const inspection_locks_report = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_INSPECTION_LOCKS_REPORT_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_INSPECTION_LOCKS_REPORT: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_INSPECTION_LOCKS_REPORT_ERROR: (state, error) => {
      state.error = error;
    }
  },

  actions: {
    LoadInspectionLocksReport({commit}, query) {
      let reqQueryStr = '';
      if (query.ignoreCache === true) {
        reqQueryStr += 'ignore-cache=t&'
      }

      if (query.period.year) {
        reqQueryStr += `year=${query.period.year}&month=${query.period.month}`
      } else {
        reqQueryStr += `from=${query.period.from}&to=${query.period.to}`
      }

      commit('SET_INSPECTION_LOCKS_REPORT_ERROR', null)
      commit('SET_INSPECTION_LOCKS_REPORT', null)
      commit('SET_INSPECTION_LOCKS_REPORT_LOADING', true)
      return api.get('reports/inspection-locks?' + reqQueryStr)
        .then((response) => {
          commit('SET_INSPECTION_LOCKS_REPORT', response)
        })
        .catch((error) => {
          commit('SET_INSPECTION_LOCKS_REPORT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_INSPECTION_LOCKS_REPORT_LOADING', false)
        })
    }
  },
}

export default inspection_locks_report
